import { createContext, useContext } from 'react';
import RootStore from 'src/stores/rootStore';

export const StoreContext = createContext({} as RootStore);

const useStores = (): RootStore => useContext(StoreContext);

export default useStores;
